import { useQuery } from 'react-query';

import { UASResult } from 'utils/UASTypes';

import { api } from '.';

import { BusinessSector } from 'typing/endpoints';

export const useBusinessSectors = () =>
	useQuery(
		'business-sectors',
		() =>
			api({ skipToken: true })
				.get('business-sectors', { searchParams: { pageSize: -1 } })
				.json<UASResult<BusinessSector>>(),
		{ staleTime: 3600000 },
	);
